import React from 'react';
import './button.css'

const Button = () => {
    return ( 
        <>
        <button>Book Consultation</button>
        </>
     );
}
 
export default Button ;